import { seedHash, seedPick } from './seedHash';

/**
 * A Reddit avatar: Snoo, as a snoovatar bust.
 *
 * The post author wore the same drawn portrait as everyone else on the panel,
 * which is wrong about the one platform where almost nobody uses a photograph.
 * A Reddit account looks like Snoo on a block of colour, and a card that is
 * imitating Reddit has to get that right for the same reason it gets the vote
 * pill right.
 *
 * Cartoon is correct HERE and nowhere else on this page. Snoo is a mascot, so
 * drawing the face is drawing the thing itself; the drawn human faces that got
 * thrown off the video covers were failing at something this is not attempting.
 */
export const SnooAvatar = ({ seed, size = 32 }: { seed: string; size?: number }) => {
  const hash = seedHash(seed);
  const background = seedPick(hash, 0, 5);
  const shirt = seedPick(hash, 1, 5);

  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 40 40"
      width={size}
      height={size}
      className="shrink-0 rounded-full"
    >
      <circle cx="20" cy="20" r="20" className={`pu-sn-bg${background}`} />
      {/* Shoulders first: the head and ears overlap them, which is how the bust
          crops on a real snoovatar. */}
      <path d="M8 40c0-7 5.4-12 12-12s12 5 12 12Z" className={`pu-sn-shirt${shirt}`} />
      <path d="M20 12.6V8" className="pu-sn-antenna" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="20" cy="6.4" r="2.3" className="pu-sn-mark" />
      <circle cx="10.6" cy="22" r="3.6" className="pu-sn-body" />
      <circle cx="29.4" cy="22" r="3.6" className="pu-sn-body" />
      <rect x="10" y="12.4" width="20" height="17.4" rx="8.7" className="pu-sn-body" />
      <ellipse cx="16.4" cy="20.4" rx="2.1" ry="2.5" className="pu-sn-eye" />
      <ellipse cx="23.6" cy="20.4" rx="2.1" ry="2.5" className="pu-sn-eye" />
      <path
        d="M16.9 25.2c1.7 1.5 4.5 1.5 6.2 0"
        className="pu-sn-smile"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
};
